<template>
  <wb-counter
    v-if="shouldShowCounter"
    :value.attr="selectedFiltersNumber"
    :mode.attr="mode"
    data-test-id="selected-filters-counter"
  ></wb-counter>
</template>

<script lang="ts">
export default { name: 'EmhSelectedFiltersCounter' };
</script>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';
import ProductFilterBase from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';
import { getSelectedFilterCounter } from '../../composables/filter.composable';

const props = defineProps({
  filters: {
    type: Array as PropType<ProductFilterBase[]>,
    required: true,
  },
  hideZeroCounter: {
    type: Boolean,
    default: false,
  },
  mode: {
    type: String,
    default: 'primary',
  },
});

const { filters, hideZeroCounter } = toRefs(props);

const selectedFiltersNumber = computed(() => getSelectedFilterCounter(filters.value));

const shouldShowCounter = computed(() => !hideZeroCounter?.value || selectedFiltersNumber.value !== 0);
</script>
